import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectorRef,
  NgZone,
} from '@angular/core';
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
} from 'rxjs';
// import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../../shared/services/api.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
//  import { LoaderComponent } from '../../shared/components/loader/loader.component';
import { LoaderService } from '../../shared/services/loader.service';
import { BehaviourSubjectService } from '../../shared/services/behaviour-subject.service';
import { Router } from '@angular/router';
import { json } from 'stream/consumers';
import {
  VoiceSearchError,
  VoiceSearchService,
} from '../../shared/services/voice-search.service';
declare var initFlowbite: any; // Add this at the top

@Component({
  selector: 'app-home-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home-banner.component.html',
  styleUrl: './home-banner.component.scss',
})
export class HomeBannerComponent implements OnInit, OnDestroy {
  guideSearchData: any;
  advanceSearchData: any;
  private searchSubject = new Subject<string>();
  constructor(
    private accountService: ApiService,
    private loaderService: LoaderService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private behaviourSubject: BehaviourSubjectService,
    private voiceSearchService: VoiceSearchService,
  ) {}

  searchIconUrl: string =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/484b3c632cd183fd33eb618400549b02b49b3973?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  actionIconUrl: string =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/7b32b2708cdb164c73707a3c5e3bc6c8fa59582e?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';

  scrapDefaultImage =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/3179c3111a162b89731a23e1cfd2428a324601d0?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  defaultImage =
    'https://cdn.builder.io/api/v1/image/assets/TEMP/b18795cb56f55f03b9aaca888100d5b63db572dc?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7';
  vehicles = [
    {
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/b18795cb56f55f03b9aaca888100d5b63db572dc?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      imageAlt: 'Tata Ace EV',
      name: 'Tata Ace EV, 2024',
    },
    {
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/3a90f4abb38710c2c5518b9d8afb234f68d5af7e?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      imageAlt: 'Honda Amaze',
      name: 'Honda Amaze, 2019',
    },
    {
      imageSrc:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/1275a82352aa8d8e6ccc0627214f09a4ec7f8214?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      imageAlt: 'Hyundai Creta',
      name: 'Hyundai Creta, 2020',
    },
  ];

  brands: any;

  marginTop: string = 'mt-4';
  minHeight: string = 'min-h-[52px]';
  headerFontWeight: string = 'font-bold';
  itemsTextSize: string = 'text-base';
  itemsFontWeight: string = 'font-bold';
  itemsWhitespace: string = '';
  itemPadding: string = '';
  itemBorder: string = '';

  showPopup: boolean = false;
  filterChips: string[] = ['Activa', 'Amaze', 'City', 'Civic', 'Ciaz'];

  suggestions = [
    {
      iconUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/52a7c4266438e8a7e6daadb76f4e7c06e3f00872?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      brandName: 'Honda',
      details: 'Activa 3G, 2015',
    },
    {
      iconUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/52a7c4266438e8a7e6daadb76f4e7c06e3f00872?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      brandName: 'Honda',
      details: 'Amaze, 2015, 1.2L Petrol',
    },
    {
      iconUrl:
        'https://cdn.builder.io/api/v1/image/assets/TEMP/52a7c4266438e8a7e6daadb76f4e7c06e3f00872?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7',
      brandName: 'Honda',
      details: 'City, 2015, Petrol',
    },
  ];
  selectedChip: string | null = null;
  searchValue: string = '';

  // Animated placeholder properties
  placeholderTexts: string[] = [
    '"Scrap"',
    '"Scrap Part"',
    '"Scrap Plastic"',
    '"Scrap Steel"',
  ];
  currentPlaceholderIndex: number = 0;
  currentAnimatedText: string = '';
  isAnimating: boolean = false;
  showCursor: boolean = true;
  placeholderAnimationInterval: any;
  cursorBlinkInterval: any;
  isInputFocused: boolean = false;
  isProgrammaticUpdate: boolean = false; // Flag to prevent duplicate API calls
  isVoiceSupported: boolean = false;
  isListening: boolean = false;
  voiceStatusText: string = '';
  voiceErrorMessage: string = '';
  isVoiceResultActive: boolean = false;

  sub: Subscription = new Subscription();

  centerBanners: any = [];
  currentIndex: number = 0; // ✅ For tracking current slide
  transitionEnabled: boolean = true;
  isLoading: boolean = true; // Add loading state
  @ViewChild('searchInput') searchInput!: ElementRef;
  selectedSuggestion: any = null;

  // Carousel auto-scroll interval
  carouselInterval: any;
  autoScrollDelay: number = 5000; // 3 seconds

  // Mouse drag support
  isDragging: boolean = false;
  dragStartX: number = 0;
  dragStartY: number = 0;
  dragCurrentX: number = 0;
  dragCurrentY: number = 0;
  dragThreshold: number = 50; // Minimum drag distance to trigger slide change

  // Touch swipe support
  touchStartX: number = 0;
  touchStartY: number = 0;
  touchCurrentX: number = 0;
  touchCurrentY: number = 0;

  selectedSearchFields = {
    make: '',
    model: '',
    year_of_manufacture: '',
    variant: '',
  };

  advanceSearch(fields = this.selectedSearchFields) {
    if (!this.searchValue.trim()) {
      this.advanceSearchData = null;
      this.showPopup = false;
      return;
    }

    if (this.searchValue.trim()) {
      this.stopPlaceholderAnimation(); // Stop animation when user starts typing
    }

    const data = {
      make: fields.make || '',
      model: fields.model || '',
      year_of_manufacture: fields.year_of_manufacture || '',
      variant: fields.variant || '',
      is_seller: true,
      part_type: 'Scrap Part', // fields.make ? (this.advanceSearchData?.suggestions?.[0]?.part_type || '') : '',
      // part_type: fields.make
      //   ? this.advanceSearchData?.suggestions[0]?.part_type
      //   : '',
      search_text: this.searchValue.trim(),
    };

    this.sub.add(
      this.accountService.getadvancePartSearch(data).subscribe({
        next: (value) => {
          if (value.success) {
            this.advanceSearchData = value.data;
            this.showPopup = true;
          } else {
            this.advanceSearchData = { smart_fill: [], suggestions: [] };
          }
          this.isLoading = false;
          this.cdr.detectChanges(); // Ensure UI updates
        },
        error: (err) => {
          this.advanceSearchData = { smart_fill: [], suggestions: [] };
          this.isLoading = false;
          this.cdr.detectChanges(); // Ensure UI updates
          // this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.cdr.detectChanges(); // Ensure UI updates
          // this.loaderService.hide();
        },
      }),
    );
  }

  // Parse comma-separated smart fill values
  parseSmartFill(value: string): {
    make?: string;
    model?: string;
    year_of_manufacture?: string;
    variant?: string;
  } {
    const parts = value.split(',').map((p) => p.trim());
    return {
      make: parts[0] || '',
      model: parts[1] || '',
      year_of_manufacture: parts[2] || '',
      variant: parts[3] || '',
    };
  }

  onChipClick(chip: any) {
    this.selectedChip = chip === this.selectedChip ? null : chip;
    this.cdr.detectChanges();

    if (chip) {
      // Structure the data from smart_fill chip
      const chipData = {
        make: chip.value || '',
        model: '',
        year_of_manufacture: '',
        variant: '',
        part_type: chip.part_type || '',
      };

      // Navigate with chip data
      this.gotoProductList(chipData, chip.part_type);
    }
  }

  onSuggestionClick(suggestion: any) {
    this.cdr.detectChanges();

    // Structure the data from suggestion
    const suggestionData = {
      make: suggestion.make || '',
      model: suggestion.model || '',
      year_of_manufacture:
        suggestion.year || suggestion.year_of_manufacture || '',
      variant: suggestion.variant || '',
      part_type: suggestion.part_type || '',
    };

    // Navigate with suggestion data
    this.gotoProductList(suggestionData, suggestion.part_type);
  }
  private navigateWithSuggestion(suggestion: any): void {
    if (!suggestion) {
      return;
    }

    localStorage.removeItem('category');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('filterState');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');

    const searchData: any = {
      make: suggestion?.make || '',
      model: suggestion?.model || '',
      year_of_manufacture:
        suggestion?.year_of_manufacture || suggestion?.year || '',
      variant: suggestion?.variant || '',
      part_type: suggestion?.part_type || suggestion?.filter_type || '',
    };

    const optionalKeys = [
      'category_list',
      'sub_category_list',
      'make_list',
      'model_list',
      'variant_list',
      'year_of_manufacture_list',
      'filter_type',
      'search_text',
      'offset',
      'limit',
    ];

    optionalKeys.forEach((key) => {
      if (suggestion && suggestion[key] !== undefined) {
        searchData[key] = suggestion[key];
      }
    });

    localStorage.setItem('guideSearchData', JSON.stringify(searchData));

    if (searchData.part_type) {
      localStorage.setItem(
        'categoryType',
        JSON.stringify(searchData.part_type),
      );
    } else {
      localStorage.removeItem('categoryType');
    }

    this.router.navigate(['/product-list']);
  }

  formatSuggestion(suggestion: any): string {
    return `${suggestion.make}, ${suggestion.model}, ${suggestion.year_of_manufacture}, ${suggestion.variant}`;
  }

  formatSearchValue(fields: any): string {
    const { make, model, year_of_manufacture, variant } = fields;
    return [make, model, year_of_manufacture, variant]
      .filter(Boolean)
      .join(', ');
  }

  onSearchTrigger() {
    const trimmed = this.searchValue.trim();
    if (!trimmed) return;

    // Navigate to product list with search text
    this.navigateBy();
  }

  onEnterKey(event: any) {
    event.preventDefault();
    this.onSearchTrigger();
  }

  performSearch(parsed: any, action?: true) {
    //  localStorage.setItem('finalguideSearchData', JSON.stringify(parsed));
    // localStorage.removeItem('guideSearchData');
    localStorage.setItem('guideSearchData', JSON.stringify(parsed));
  }

  navigateBy() {
    // Clear ALL localStorage items to ensure clean state for new search
    localStorage.removeItem('category');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('filterState');
    localStorage.removeItem('seemore');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('product_categoryType');

    // Clear any existing guideSearchData before setting new one
    localStorage.removeItem('guideSearchData');

    // Build the payload as in advanceSearch
    const trimmedTerm = this.searchValue.trim();
    const fields = { ...this.selectedSearchFields };
    let data: any = {};

    const hasStructuredSelection = Object.values(fields).some(
      (value) => !!value,
    );

    if (!hasStructuredSelection && trimmedTerm) {
      const parsed = this.parseSmartFill(trimmedTerm);
      const parsedValues = Object.values(parsed).filter((value) => !!value);
      if (parsedValues.length > 1) {
        Object.assign(fields, parsed);
        this.selectedSearchFields = { ...fields };
      }
    }

    if (
      fields.make ||
      fields.model ||
      fields.year_of_manufacture ||
      fields.variant
    ) {
      data = {
        make: fields.make || '',
        model: fields.model || '',
        year_of_manufacture: fields.year_of_manufacture || '',
        variant: fields.variant || '',
        part_type:
          this.advanceSearchData?.suggestions?.[0]?.part_type || 'Used Part',
        search_text: trimmedTerm,
      };
    } else {
      if (this.advanceSearchData?.suggestions?.length > 0) {
        data = {
          search_text: trimmedTerm,
          part_type:
            this.advanceSearchData?.suggestions?.[0]?.part_type || 'Used Part',
        };
      } else {
        data = {
          search_text: trimmedTerm,
        };
      }
    }

    localStorage.setItem('guideSearchData', JSON.stringify(data));

    // Set categoryType based on search results or default to 'Used Part'
    const partType = data.part_type || 'Used Part';
    localStorage.setItem('categoryType', JSON.stringify(partType));

    // Clear behavior subject search term to prevent old header search from persisting
    this.behaviourSubject.setSearchTerm('');
    this.behaviourSubject.clearSelectedFilters();

    // Clear search state
    this.searchValue = '';
    this.showPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };

    // Restart placeholder animation after clearing search
    this.resetPlaceholderAnimation();
    setTimeout(() => {
      this.startPlaceholderAnimation();
    }, 500);

    this.router.navigate(['/product-list']);
  }

  filterSuggestions(): any[] {
    if (!this.selectedChip) return this.suggestions;
    return this.suggestions.filter((s) =>
      s.details.toLowerCase().includes(this.selectedChip!.toLowerCase()),
    );
  }

  // onChipClick(chip: string) {
  //   this.selectedChip = chip === this.selectedChip ? null : chip;
  // }

  onFocus() {
    this.showPopup = true;
    this.isInputFocused = true;
    this.stopPlaceholderAnimation(); // Pause animation when focused
  }

  onBlur() {
    this.isInputFocused = false;
    // Optional: Delay to allow clicks inside popup
    setTimeout(() => {
      this.showPopup = false;
      // Resume animation after a short delay
      setTimeout(() => {
        if (!this.searchValue) {
          // Reset animation state before restarting
          this.resetPlaceholderAnimation();
          this.startPlaceholderAnimation();
        }
      }, 500);
    }, 200);
  }

  getImageClass(item: any): string {
    return 'object-contain shrink-0 self-stretch my-auto aspect-[1.79] w-[43px] cursor-pointer';
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isVoiceSupported = this.voiceSearchService.isSupported();
      this.bindVoiceSearch();
      this.getBannerList();
      this.defaultSearch();
      // Start the placeholder animation
      this.searchSubject
        .pipe(
          debounceTime(500), // wait after user stops typing
          distinctUntilChanged(),
        )
        .subscribe(() => {
          this.advanceSearch();
        });

      setTimeout(() => {
        this.startPlaceholderAnimation();
      }, 1000);
      // Start carousel auto-scroll
      this.carouselInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.nextSlide();
        });
      }, this.autoScrollDelay);
    }
  }

  getBannerList() {
    this.loaderService.show();
    try {
      this.isLoading = true; // Set loading to true when starting
      let screenType = 'Desktop';

      if (window.innerWidth < 640) {
        screenType = 'Mobile';
      } else if (window.innerWidth >= 640 && window.innerWidth < 1024) {
        screenType = 'Tablet';
      } else {
        screenType = 'Desktop';
      }

      let data = {
        action_type: 'For Users',
        banner_device: screenType,
        type: '',
        banner_group: '',
        offset: 0,
        limit: 10,
      };

      this.sub.add(
        this.accountService.bannerList(data).subscribe({
          next: (value) => {
            if (value.success) {
              this.centerBanners = value.data.flatMap(
                (item: any) => item.images || [],
              );

              // Initialize carousel after data is loaded
              setTimeout(() => {
                if (typeof initFlowbite === 'function') {
                  initFlowbite();
                }
              }, 100);
            } else {
              this.centerBanners = [];
            }
            this.isLoading = false; // Set loading to false when done
          },
          error: (err) => {
            console.error('Error loading banners:', err);
            this.centerBanners = [];
            this.isLoading = false; // Set loading to false on error
            this.loaderService.hide();
          },
          complete: () => {
            this.isLoading = false;
            this.loaderService.hide();
          },
        }),
      );
    } catch (error) {
      console.error('Error in getBannerList:', error);
      this.isLoading = false; // Set loading to false on error
      this.loaderService.show();
      throw error;
    }
  }

  defaultSearch() {
    this.loaderService.show();
    try {
      this.isLoading = true; // Set loading to true when starting
      let data = {
        // banner_type: '',
        // description: '',
        // pg_line: '',
        // api_url: '',
        // limit: 10,
        // offset: 0,
      };

      this.sub.add(
        this.accountService.guideSearch(data).subscribe({
          next: (value) => {
            if (value.success) {
              this.guideSearchData = value.data;
              setTimeout(() => {
                if (typeof initFlowbite === 'function') {
                  initFlowbite();
                }
              }, 100);
            } else {
              // this.centerBanners = [];
              console.warn('No banner data received');
            }
            this.isLoading = false; // Set loading to false when done
          },
          error: (err) => {
            console.error('Error loading banners:', err);
            // this.centerBanners = [];
            this.isLoading = false; // Set loading to false on error
            this.loaderService.hide();
          },
          complete: () => {
            this.isLoading = false;
            this.loaderService.hide();
          },
        }),
      );
    } catch (error) {
      console.error('Error in getBannerList:', error);
      this.isLoading = false; // Set loading to false on error
      this.loaderService.show();
      throw error;
    }
  }
  goToSlide(index: number) {
    this.currentIndex = index;
  }

  // Add missing carousel methods
  previousSlide() {
    if (this.centerBanners.length > 1) {
      this.currentIndex =
        this.currentIndex === 0
          ? this.centerBanners.length - 1
          : this.currentIndex - 1;
    }
  }

  nextSlide() {
    if (this.centerBanners.length > 1) {
      this.currentIndex =
        this.currentIndex === this.centerBanners.length - 1
          ? 0
          : this.currentIndex + 1;
    }
  }

  goToSlideByIndex(index: number) {
    if (index >= 0 && index < this.centerBanners.length) {
      // Reset auto-scroll timer when manually clicking an indicator
      if (this.carouselInterval) {
        clearInterval(this.carouselInterval);
      }

      this.currentIndex = index;
      this.cdr.detectChanges();

      // Restart auto-scroll after manual selection
      this.carouselInterval = setInterval(() => {
        this.ngZone.run(() => {
          this.nextSlide();
        });
      }, this.autoScrollDelay);
    }
  }

  // Mouse drag event handlers
  onMouseDown(event: MouseEvent): void {
    if (this.centerBanners.length <= 1) return;

    this.isDragging = true;
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    this.dragCurrentX = event.clientX;
    this.dragCurrentY = event.clientY;

    // Pause auto-scroll when dragging starts
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }

    // Prevent text selection during drag
    event.preventDefault();
    this.cdr.detectChanges();
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.isDragging) return;

    this.dragCurrentX = event.clientX;
    this.dragCurrentY = event.clientY;

    // Prevent text selection during drag
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent): void {
    if (!this.isDragging) return;

    const dragDistanceX = Math.abs(this.dragCurrentX - this.dragStartX);
    const dragDistanceY = Math.abs(this.dragCurrentY - this.dragStartY);

    // Only trigger slide change if:
    // 1. Horizontal drag distance > threshold (50px)
    // 2. Horizontal drag is greater than vertical drag (prevents accidental triggers during scroll)
    if (dragDistanceX > this.dragThreshold && dragDistanceX > dragDistanceY) {
      if (this.dragCurrentX < this.dragStartX) {
        // Dragged left - go to next slide
        this.nextSlide();
      } else if (this.dragCurrentX > this.dragStartX) {
        // Dragged right - go to previous slide
        this.previousSlide();
      }
    }

    // Reset drag state
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartY = 0;
    this.dragCurrentX = 0;
    this.dragCurrentY = 0;

    // Resume auto-scroll after drag completes
    this.carouselInterval = setInterval(() => {
      this.ngZone.run(() => {
        this.nextSlide();
      });
    }, this.autoScrollDelay);

    this.cdr.detectChanges();
  }

  onMouseLeave(event: MouseEvent): void {
    if (!this.isDragging) return;

    // Complete drag if mouse leaves during drag
    this.onMouseUp(event);
  }

  // Touch event handlers for mobile swipe
  onTouchStart(event: TouchEvent): void {
    if (this.centerBanners.length <= 1) return;

    const touch = event.touches[0];
    if (!touch) return;

    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
    this.touchCurrentX = touch.clientX;
    this.touchCurrentY = touch.clientY;

    // Pause auto-scroll when touch starts
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  }

  onTouchMove(event: TouchEvent): void {
    const touch = event.touches[0];
    if (!touch) return;

    this.touchCurrentX = touch.clientX;
    this.touchCurrentY = touch.clientY;
  }

  onTouchEnd(event: TouchEvent): void {
    const touch = event.changedTouches[0];
    if (!touch) return;

    const touchDistanceX = Math.abs(this.touchCurrentX - this.touchStartX);
    const touchDistanceY = Math.abs(this.touchCurrentY - this.touchStartY);

    // Only trigger slide change if:
    // 1. Horizontal swipe distance > threshold (50px)
    // 2. Horizontal swipe is greater than vertical swipe (prevents accidental triggers during scroll)
    if (
      touchDistanceX > this.dragThreshold &&
      touchDistanceX > touchDistanceY
    ) {
      if (this.touchCurrentX < this.touchStartX) {
        // Swiped left - go to next slide
        this.nextSlide();
      } else if (this.touchCurrentX > this.touchStartX) {
        // Swiped right - go to previous slide
        this.previousSlide();
      }
    }

    // Reset touch state
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.touchCurrentX = 0;
    this.touchCurrentY = 0;

    // Resume auto-scroll after swipe completes
    this.carouselInterval = setInterval(() => {
      this.ngZone.run(() => {
        this.nextSlide();
      });
    }, this.autoScrollDelay);

    this.cdr.detectChanges();
  }

  seeMoregotoProductList(data: any) {
    // Handle see more navigation - match header behavior
    localStorage.removeItem('seemore');
    localStorage.removeItem('category');
    localStorage.removeItem('filterState');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('product_categoryType');

    localStorage.setItem('seemore', data);

    // Set category type based on the section
    if (data === 'popular_brand') {
      localStorage.setItem('categoryType', JSON.stringify('used part'));
    } else if (data === 'popular_model') {
      localStorage.setItem('categoryType', JSON.stringify('used part'));
    } else if (data === 'popular_variant') {
      localStorage.setItem('categoryType', JSON.stringify('used part'));
    } else if (data === 'popular_year') {
      localStorage.setItem('categoryType', JSON.stringify('used part'));
    } else if (data === 'popular_part') {
      localStorage.setItem('categoryType', JSON.stringify('used part'));
    } else if (data === 'popular_scrap') {
      localStorage.setItem('categoryType', JSON.stringify('Scrap Part'));
    }

    // Clear behavior subject search term to prevent old header search from persisting
    this.behaviourSubject.setSearchTerm('');
    this.behaviourSubject.clearSelectedFilters();

    // Clear search state
    this.searchValue = '';
    this.showPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };

    // Restart placeholder animation after clearing search
    this.resetPlaceholderAnimation();
    setTimeout(() => {
      this.startPlaceholderAnimation();
    }, 500);

    this.router.navigate(['/product-list']);
  }

  gotoProductList(data: any, type?: any) {
    // Follow the same pattern as header component
    // Clear ALL localStorage items to ensure clean state
    localStorage.removeItem('filterState');
    localStorage.removeItem('category');
    localStorage.removeItem('guideSearchData');
    localStorage.removeItem('MyGarageData');
    localStorage.removeItem('categoryType');
    localStorage.removeItem('mostSearchedModel');
    localStorage.removeItem('SpareCategory');
    localStorage.removeItem('seemore');
    localStorage.removeItem('product_categoryType');

    const searchData = {
      make: data?.make || '',
      model: data?.model || '',
      year_of_manufacture: data?.year_of_manufacture || '',
      variant: data?.variant || '',
      part_type: data?.make ? data?.part_type : '',
    };

    localStorage.setItem('guideSearchData', JSON.stringify(searchData));

    if (type) {
      localStorage.setItem('categoryType', JSON.stringify(type));
    }

    // Clear behavior subject search term to prevent old header search from persisting
    this.behaviourSubject.setSearchTerm('');
    this.behaviourSubject.clearSelectedFilters();

    // Clear search popup state
    this.searchValue = '';
    this.showPopup = false;
    this.advanceSearchData = null;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };

    // Restart placeholder animation after clearing search
    this.resetPlaceholderAnimation();
    setTimeout(() => {
      this.startPlaceholderAnimation();
    }, 500);

    this.router.navigate(['/product-list']);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.voiceSearchService.destroy();
    this.stopPlaceholderAnimation();
    this.stopCursorBlink();
    if (this.carouselInterval) {
      clearInterval(this.carouselInterval);
    }
  }

  private bindVoiceSearch(): void {
    this.sub.add(
      this.voiceSearchService.listening$.subscribe((isListening: boolean) => {
        this.isListening = isListening;
        this.voiceStatusText = isListening ? 'Listening...' : '';
        if (isListening) {
          this.voiceErrorMessage = '';
        }
        this.cdr.detectChanges();
      }),
    );

    this.sub.add(
      this.voiceSearchService.results$.subscribe((result) => {
        if (!result.isFinal) {
          this.searchValue = result.transcript;
          this.isVoiceResultActive = false;
          this.cdr.detectChanges();
          return;
        }

        this.searchValue = result.transcript;
        this.isVoiceResultActive = true;
        this.onInputChange();
        this.searchInput?.nativeElement?.focus();
        this.cdr.detectChanges();
      }),
    );

    this.sub.add(
      this.voiceSearchService.errors$.subscribe((error: VoiceSearchError) => {
        this.handleVoiceError(error);
      }),
    );
  }

  onVoiceSearchClick(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.isVoiceSupported) {
      this.voiceErrorMessage = 'Voice search is not supported in this browser.';
      this.cdr.detectChanges();
      return;
    }

    this.voiceErrorMessage = '';

    if (this.isListening) {
      this.voiceSearchService.stopListening();
      return;
    }

    this.startFreshVoiceListening();
  }

  private startFreshVoiceListening(): void {
    this.searchValue = '';
    this.isVoiceResultActive = false;
    this.selectedChip = null;
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    this.advanceSearchData = null;
    this.showPopup = true;

    this.voiceSearchService.startListening({
      lang: 'en-IN',
      interimResults: true,
      maxAlternatives: 1,
    });
  }

  private handleVoiceError(error: VoiceSearchError): void {
    this.voiceErrorMessage = error.code === 'aborted' ? '' : error.message;
    this.cdr.detectChanges();
  }

  // Animated placeholder methods
  startPlaceholderAnimation() {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.startCursorBlink();
    this.animatePlaceholder();
  }

  stopPlaceholderAnimation() {
    this.isAnimating = false;
    this.stopCursorBlink();
    if (this.placeholderAnimationInterval) {
      clearTimeout(this.placeholderAnimationInterval);
      this.placeholderAnimationInterval = null;
    }
  }

  resetPlaceholderAnimation() {
    this.currentAnimatedText = '';
    this.currentPlaceholderIndex = 0;
    this.isAnimating = false;
    this.showCursor = false;
    if (this.placeholderAnimationInterval) {
      clearTimeout(this.placeholderAnimationInterval);
      this.placeholderAnimationInterval = null;
    }
    if (this.cursorBlinkInterval) {
      clearInterval(this.cursorBlinkInterval);
      this.cursorBlinkInterval = null;
    }
  }

  startCursorBlink() {
    this.cursorBlinkInterval = setInterval(() => {
      this.ngZone.run(() => {
        this.showCursor = !this.showCursor;
        this.cdr.detectChanges();
      });
    }, 500);
  }

  stopCursorBlink() {
    if (this.cursorBlinkInterval) {
      clearInterval(this.cursorBlinkInterval);
      this.cursorBlinkInterval = null;
    }
    this.showCursor = false;
  }

  animatePlaceholder() {
    const currentText = this.placeholderTexts[this.currentPlaceholderIndex];
    let currentCharIndex = 0;

    // Clear current text first
    this.currentAnimatedText = '';

    const typeWriter = () => {
      if (!this.isAnimating) return; // Guard against updates after stop
      if (currentCharIndex < currentText.length) {
        this.ngZone.run(() => {
          this.currentAnimatedText += currentText[currentCharIndex];
          currentCharIndex++;
          this.cdr.detectChanges();
        });
        this.placeholderAnimationInterval = setTimeout(typeWriter, 100); // Adjust speed here
      } else {
        // Wait before starting next text
        this.placeholderAnimationInterval = setTimeout(() => {
          if (!this.isAnimating) return;
          this.ngZone.run(() => {
            this.currentPlaceholderIndex =
              (this.currentPlaceholderIndex + 1) % this.placeholderTexts.length;
            this.cdr.detectChanges();
          });
          this.animatePlaceholder();
        }, 2000); // Wait 2 seconds before next text
      }
    };

    typeWriter();
  }

  getCurrentPlaceholder(): string {
    // When input is focused, show static placeholder
    if (this.isInputFocused) {
      return 'Search for Scrap';
    }

    const baseText = this.currentAnimatedText || this.placeholderTexts[0];
    // Add blinking cursor effect
    return (
      'Search for ' +
      baseText +
      (this.isAnimating && this.showCursor ? '|' : '')
    );
  }

  // Watch for search value changes
  onSearchValueChange() {
    if (!this.searchValue.trim() && !this.isAnimating) {
      // Restart animation if search is cleared
      setTimeout(() => {
        this.resetPlaceholderAnimation();
        this.startPlaceholderAnimation();
      }, 1000);
    }
  }

  // Handle input event - uses RxJS Subject for debouncing
  onInputChange() {
    if (this.isProgrammaticUpdate) {
      this.onSearchValueChange();
      return;
    }

    if (!this.isListening) {
      this.isVoiceResultActive = false;
    }

    // Clear previous search fields when new search input starts
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    this.selectedChip = null;

    // Only call API if search term is not empty
    if (!this.searchValue.trim()) {
      this.advanceSearchData = null;
      this.showPopup = false;
      this.onSearchValueChange();
      return;
    }

    // Use RxJS Subject for debounced API call
    this.searchSubject.next(this.searchValue);

    this.onSearchValueChange();
  }

  onSearchInput(event: any) {
    // This method can be used as an alternative to onInputChange
    // Clear previous search fields when new search input starts
    this.selectedSearchFields = {
      make: '',
      model: '',
      year_of_manufacture: '',
      variant: '',
    };
    this.selectedChip = null;
    this.advanceSearchData = null;

    // Only call API if search term is not empty
    if (!this.searchValue.trim()) {
      this.showPopup = false;
      return;
    }

    // Trigger the search via Subject
    this.searchSubject.next(this.searchValue);
  }
}
